module.exports = __webpack_public_path__ + "img/power-dev-3_2x.8df4fc64.png";